import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; //bootstrap code

import firebase from 'firebase/app'; //firebase for authentification
import 'firebase/auth';
import 'firebase/database'; // acceess active database

import { BrowserRouter } from 'react-router-dom';
import App from './App';

var config = {
  apiKey: "AIzaSyAEe75x6cxrhZXYeRWyniHbPff2kQDHCWU",
  authDomain: "info340-speneeds.firebaseapp.com",
  databaseURL: "https://info340-speneeds.firebaseio.com",
  projectId: "info340-speneeds",
  storageBucket: "info340-speneeds.appspot.com",
  messagingSenderId: "840083893781"
};
firebase.initializeApp(config);


ReactDOM.render(<BrowserRouter><App /></BrowserRouter>, document.getElementById('root'));
